module.exports = __webpack_public_path__ + "img/app-screen_5.e954d135.webp";